import { Controller } from "@hotwired/stimulus"
import { sendSlideImpressionBatch } from "../utils/slide_impression_batch"

export default class extends Controller {
  static targets = ["slide"]
  static values = { endpoint: String }

  connect() {
    if (this.fired) return
    if (!this.hasEndpointValue || !this.slideTargets.length) return

    this.fired = true
    sendSlideImpressionBatch(this.endpointValue, this.slideTargets)
  }
}
